// Angular modules.
import { Injectable } from '@angular/core';
// Zenklub interfaces.
import { IUserPreferences } from 'app/interfaces/userpreferences.interface';

// Zenklub services.
import { UserService } from './user.service';

@Injectable()
export class CurrencyService {
	// User preferences.
	userPref: IUserPreferences;

	// Constructor method.
	constructor(private user: UserService) {
		this.userPref = this.user.getUserLocalPreferences();
	}

	// Get formated value for screen.
	public getValueForScreen(value: number, format?: string): string {
		let newValue: string = value.toFixed(2);
		const signal: string = this.getCurrencySymbol(format);

		if (format.toUpperCase() === 'BRL') {
			newValue = newValue.replace('.', ',');
		}
		return signal + ' ' + newValue;
	}

	public getCurrencySymbol(format?: string) {
		format = !format ? this.userPref.CurrencySymbol : format;

		let signal: string;
		switch (format.toUpperCase()) {
			case 'BRL':
				signal = 'R$';
				break;
			case 'USD':
				signal = '$';
				break;
			case 'EUR':
				signal = '€';
				break;
			default:
				signal = '$';
				break;
		}

		return signal;
	}

	// Format value with two decimal places.
	public formatWithDecimals(value: number, decSeparator?: string): string {
		if (!decSeparator) {
			this.userPref = this.user.getUserLocalPreferences();
			let formated: string = (Math.round(value * 100) / 100).toFixed(2);
			const userSeparator: string = this.userPref.DecimalSeparator;
			const avoidSeparator: string = userSeparator === '.' ? ',' : '.';

			if (formated.indexOf(avoidSeparator) > -1) {
				formated = formated.replace(avoidSeparator, userSeparator);
			}
			return formated;
		} else {
			let formated: string = (Math.round(value * 100) / 100).toFixed(2);
			const avoidSeparator: string = decSeparator === '.' ? ',' : '.';

			if (formated.indexOf(avoidSeparator) > -1) {
				formated = formated.replace(avoidSeparator, decSeparator);
			}
			return formated;
		}
	}
}
